import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { all_routes } from "../../../Router/all_routes";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { SKIP_SUBSCRIPTION_CHECK } from "../../../environment.jsx";


/**
 * Composant de garde d'abonnement : vérifie si l'utilisateur a un abonnement valide
 * Agit comme une sécurité supplémentaire après le SessionControl.
 * * @param {string} storageKey - La clé dans le localStorage (ex: "user")
 * @param {string} redirectTo - Le chemin vers lequel rediriger si l'abonnement est expiré
 */
const AbonnementControl = ({ storageKey = "user", redirectTo = all_routes.signin }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (SKIP_SUBSCRIPTION_CHECK) {
            console.log("⏭️ SKIP_SUBSCRIPTION_CHECK est actif. Bypass du contrôle d'abonnement.");
            return;
        }

        const MySwal = withReactContent(Swal);

        const raw = localStorage.getItem(storageKey);

        // 1. Vérification de la présence de la session
        if (!raw) {
            navigate(redirectTo);
            return;
        }

        try {
            const data = JSON.parse(raw);
            console.log("Données de session récupérées pour l'abonnement :", data);

            // 2. Extraction de l'abonnement selon ta structure JSON (dernier_abonnement)
            const abonnement = data.dernier_abonnement;

            if (!data.dernier_abonnement || Object.keys(data.dernier_abonnement).length === 0) {
                console.warn("Aucun abonnement trouvé dans la session.");
                MySwal.fire({
                    icon: "warning",
                    // title: "Aucun abonnement",
                    html: `Vous n'avez pas d'abonnement actif.<br/>Veuillez vous abonner pour continuer.`,
                    confirmButtonText: "S'abonner",
                    confirmButtonColor: "#FF4500",
                    allowOutsideClick: false, // Bloquant
                    allowEscapeKey: false,   // Bloquant
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (data.role && data.role != null) {
                            localStorage.removeItem("user");       // Supprimer l'utilisateur
                            localStorage.removeItem("restaurant");  // Supprimer le restaurant
                            localStorage.removeItem("selectedRestaurantId");   // Supprimer l'id du restaurant
                            navigate(all_routes.signin);           // Redirection vers la page de connexion
                        } else {
                            navigate(all_routes.pricing);
                        }
                    }
                });
                return; // Important: arrêter l'exécution ici
            }

            // 3. Logique de comparaison de date
            const today = new Date();
            const expirationDate = new Date(abonnement.date_fin);

            const isExpired = today > expirationDate;

            if (isExpired) {
                console.log("L'abonnement est expiré.");

                MySwal.fire({
                    icon: "warning",
                    // title: "Abonnement expiré",
                    html: `Votre accès a expiré le <b>${expirationDate.toLocaleDateString('fr-FR')}</b>.<br/>Veuillez renouveler pour continuer.`,
                    confirmButtonText: "S'abonner / Renouveler",
                    confirmButtonColor: "#FF4500",
                    // allowOutsideClick: false, // Bloquant
                    allowEscapeKey: false,   // Bloquant
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(all_routes.pricing);
                    }
                });

                return;
            } else {
                console.log("L'abonnement est valide.");
            }
        } catch (e) {
            console.error("Erreur structure abonnement problematique", e);
            // En cas d'erreur de parsing, on ne redirige pas forcément pour éviter les boucles, 
            // mais on log l'erreur.
        }
    }, [navigate, storageKey, redirectTo]);

    return null; // Ce composant ne rend rien
};

AbonnementControl.propTypes = {
    storageKey: PropTypes.string,
    redirectTo: PropTypes.string,
};

export default AbonnementControl;